import { render, staticRenderFns } from "./CalendarEventEditorAdditionalInformation.vue?vue&type=template&id=65761566&scoped=true&lang=pug&"
import script from "./CalendarEventEditorAdditionalInformation.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventEditorAdditionalInformation.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventEditorAdditionalInformation.vue?vue&type=style&index=0&id=65761566&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65761566",
  null
  
)

export default component.exports